import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import DownChevron from 'assets/images/fabricQualities/chevron.svg';
import './resolveDropDown.scss';
import InitiateReturnModal from './menuModals/initiateReturnModal/initiateReturn';
import RefundOtpModal from './MenuOptions/RefundModal';
import RejectionModal from './MenuOptions/RejectModal/RejectModal';
import ApprovedModal from './MenuOptions/ApprovedModal/ApprovedModal';
import IssueResolutionModal from './MenuOptions/IssueResolutionModal/IssueResolutionModal';
import { ISSUE_STATUS, WHATSAPP_VERIFICATION_TYPE } from './MenuOptions/constants';
import { getOtpForWhatsAppVerification, markIssueResolved } from 'store/actions/IssuePanelActions';
import { connect } from 'react-redux';

const ResolveDropdown = ({
  record,
  toastVisible,
  setToastVisible,
  setToastText,
  getOtpForWhatsAppVerification,
  markIssueResolved,
}) => {
  const RESOLVE_MENUS = {
    APPROVED: 0,
    REJECT: 1,
    PICK_UP: 2,
    RETURN_OTP: 3,
  };
  const [issueResolutionModalVisible, setIssueResolutionModalVisible] = useState(false);
  const [initiateReturnModalVisible, setInitiateReturnModalVisible] = useState(false);
  const [approvedModalVisible, setApprovedModalVisible] = useState(false);
  const [rejectModalVisible, setrejectModalVisible] = useState(false);
  const [issueRefundModalVisible, setIssueRefundModalVisible] = useState(false);

  const handleGenerateOtp = (isResend = false) => {
    getOtpForWhatsAppVerification({
      verificationType: WHATSAPP_VERIFICATION_TYPE.CUSTOMER_RETURN,
      quantity: record?.totalQuantity,
      customerWhatsappNumber: record?.customerWhatsappNumber,
      fabricId: record?.fabricId,
      orderId: record?.orderId,
    }).then((resp) => {
      if (resp?.code === 200 && !isResend) {
        setIssueRefundModalVisible(true);
      }
    });
  };
  const handleFormSubmitWithVerification = (code) => {
    markIssueResolved({
      otp: code,
      orderId: record?.orderId,
    }).then((resp) => {
      if (resp?.success) {
        setIssueRefundModalVisible(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    });
  };
  const handleMenuClick = (e) => {
    const menuIndex = parseInt(e.key);
    const newVisibleState = new Array(3).fill(false);
    newVisibleState[menuIndex] = true;
    if (menuIndex === RESOLVE_MENUS.APPROVED) setApprovedModalVisible(true);
    if (menuIndex === RESOLVE_MENUS.REJECT) setrejectModalVisible(true);
    if (menuIndex === RESOLVE_MENUS.PICK_UP) setIssueResolutionModalVisible(true);
    if (menuIndex === RESOLVE_MENUS.RETURN_OTP) {
      handleGenerateOtp();
    }
  };
  const getIssueStatusLabel = (issueStatus) => {
    switch (issueStatus) {
      case ISSUE_STATUS.RETURN_INITIATED:
        return 'Ready for pickup';
      case ISSUE_STATUS.REFUND_ISSUED:
        return 'Refund Issued';
      default:
        return 'Resolve';
    }
  };

  let menuItems;

  switch (record.issueStatus) {
    case ISSUE_STATUS.RETURN_INITIATED:
      menuItems = [<Menu.Item key={RESOLVE_MENUS.PICK_UP}>Enter resolution details</Menu.Item>];
      break;

    case ISSUE_STATUS.REFUND_ISSUED:
      menuItems = [<Menu.Item key={RESOLVE_MENUS.RETURN_OTP}>Resolve</Menu.Item>];
      break;

    default:
      menuItems = [
        <Menu.Item key={RESOLVE_MENUS.APPROVED}>Approve</Menu.Item>,
        <Menu.Item key={RESOLVE_MENUS.REJECT}>Reject</Menu.Item>,
      ];
  }

  const menu = (
    <Menu className="resolve-dropdown-menu" onClick={handleMenuClick}>
      {menuItems}
    </Menu>
  );

  return (
    <>
      <Dropdown
        overlay={menu}
        trigger={['click']}
        placement="bottomLeft"
        disabled={record?.isInternational}>
        <div className="resolve-dropdown">
          <span
            className={
              [ISSUE_STATUS.REFUND_ISSUED, ISSUE_STATUS.RETURN_INITIATED].includes(
                record?.issueStatus,
              )
                ? 'ready-for-pickup-text'
                : 'resolve-text'
            }>
            {getIssueStatusLabel(record?.issueStatus)}
          </span>
          {!record?.isInternational && <img src={DownChevron} alt="drop-down-icon" />}
        </div>
      </Dropdown>

      {approvedModalVisible && (
        <ApprovedModal
          record={record}
          approvedModalVisible={approvedModalVisible}
          setApprovedModalVisible={setApprovedModalVisible}
          initiateReturnModalVisible={initiateReturnModalVisible}
          setInitiateReturnModalVisible={setInitiateReturnModalVisible}
          issueResolutionModalVisible={issueResolutionModalVisible}
          setIssueResolutionModalVisible={setIssueResolutionModalVisible}
        />
      )}
      
      {rejectModalVisible && (
        <RejectionModal
          record={record}
          toastVisible={toastVisible}
          setToastVisible={setToastVisible}
          setToastText={setToastText}
          rejectModalVisible={rejectModalVisible}
          setrejectModalVisible={setrejectModalVisible}
        />
      )}
      {initiateReturnModalVisible && (
        <InitiateReturnModal
          record={record}
          setToastVisible={setToastVisible}
          setToastText={setToastText}
          initiateReturnModalVisible={initiateReturnModalVisible}
          setInitiateReturnModalVisible={setInitiateReturnModalVisible}
        />
      )}
      {issueResolutionModalVisible && (
        <IssueResolutionModal
          record={record}
          status={record.issueStatus || ISSUE_STATUS.PENDING}
          toastVisible={toastVisible}
          setToastVisible={setToastVisible}
          setToastText={setToastText}
          issueResolutionModalVisible={issueResolutionModalVisible}
          setIssueResolutionModalVisible={setIssueResolutionModalVisible}
        />
      )}
      {issueRefundModalVisible && (
        <RefundOtpModal
          issueRefundModalVisible={issueRefundModalVisible}
          setIssueRefundModalVisible={setIssueRefundModalVisible}
          handleGenerateOtp={handleGenerateOtp}
          handleFormSubmitWithVerification={handleFormSubmitWithVerification}
          whatsappNumber={record?.whatsappNumber}
        />
      )}
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getOtpForWhatsAppVerification: (data) => dispatch(getOtpForWhatsAppVerification(data)),
  markIssueResolved: (data) => dispatch(markIssueResolved(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResolveDropdown);
